import { getQueryParams, getPathVariables } from '../../Services/utils'

const locationReducer = (state = {}, action) => {

  var location = window.location

  return {
    ...state,
    ...location,
    params: getQueryParams(),
    paths: getPathVariables(),
    timeStamp: new Date()
  }

}

export default locationReducer;


// WEBPACK FOOTER //
// ./src/reducers/location/index.js